import { useState } from "react";
import Login from "./components/Login";
import Upload from "./components/Upload";
import Dashboard from "./components/Dashboard";
import Rewards from "./components/Rewards";

export default function App() {
  const [user, setUser] = useState(null); // บัญชีผู้ใช้
  const [points, setPoints] = useState(0); // แต้มสะสม
  const [page, setPage] = useState("login"); // หน้าเว็บ

  return (
    <div>
      {!user && page === "login" && (
        <Login setUser={setUser} setPage={setPage} />
      )}

      {user && page === "upload" && (
        <Upload setPoints={setPoints} points={points} setPage={setPage} />
      )}

      {user && page === "dashboard" && (
        <Dashboard points={points} setPage={setPage} />
      )}

      {user && page === "rewards" && (
        <Rewards points={points} setPoints={setPoints} setPage={setPage} />
      )}
    </div>
  );
}
